/* global $:false */

import tmpl_app_option from '../templates/menu-app-option.dot';
import tmpl_menu from '../templates/menu.dot';
import tmpl_option from '../templates/menu-option.dot';
import tmpl_substitutes_list from '../templates/menu-substitutes-list.dot';
import tmpl_substitution_tooltip from '../templates/menu-substitution-tooltip.dot';
import tmpl_user_profile_link from '../templates/user-profile-link.dot';

// "Module" responsible for showing the menu UI and navigation within modules.
var menu = function(core) {
    window.console.log("MENU: initializing");

    var _$container = $('#'+core.getAppInstanceId()),
        _menuPresenter,
        _isRunning = false;

    _menuPresenter = new MenuPresenter(core, _$container);

    return{
        init: function() {
            _menuPresenter.start();
            _isRunning = !_isRunning;
        },
        pause: function() {
            _menuPresenter.stop();
            _isRunning = !_isRunning;
        },
        resume: function() {
            if (!_isRunning) {
                _menuPresenter.start();
                _isRunning = !_isRunning;
            }
        },
        destroy: function() {

        }
    };
};

// container: the HTML selector for the enclosing element
//
// callbacks:
//
// * `menuClick`: called when the user clicks a menu item
var MenuView = function(core, $container) {

    var _appInfo = core.getAppInfoModel();

    var _$headerContainer = $(tmpl_menu({
            appName: _appInfo.appId,
            shortAppName: core.translateString("cob.app", "short-app-name"),
            logo: _appInfo.appLogo
        })),
        _$menuBtn = $('.js-menu-btn', _$headerContainer),
        _$navContainer = $('.js-nav', _$headerContainer),
        _$menusContainer = $(".js-top-menu", _$headerContainer),
        _$appsContainer = $(".js-cobapps", _$headerContainer),
        _$userInfoContainer = $('.js-app-context', _$headerContainer),
        _$usernameContainer = $(".js-appuser", _$userInfoContainer),
        _$userDropdownMenu = $(".js-additional-opts", _$userInfoContainer),
        _$substitutionWarning = $(".js-substitute-warning", _$userInfoContainer);

    var _$window = $(window),
        _$smartMenu;

    var _removeUsersToSubstituteList = function(){
        $(".js-substituted-users-list", _$userDropdownMenu).remove();
    };

    var _addSubstitutionMsg = function(warningType, classToRemove, substitute){
        _$substitutionWarning.addClass(warningType);
        _$substitutionWarning.tooltip('destroy');
        _$substitutionWarning.tooltip({
            placement: "bottom",
            html:true,
            title: tmpl_substitution_tooltip({
               title:core.translateString("cob.menu", warningType),
               substitute: substitute
            })
        });
        _$substitutionWarning.removeClass(classToRemove + " hidden");
    };

    var _showUserIsImpersonating = function(){
        _$userInfoContainer.addClass("label impersonation-warning");
    };

    var _hideUserIsImpersonating = function(){
        _$userInfoContainer.removeClass("label impersonation-warning");
    };

    var _isSmallDevice = function() {
        // The 496px is based in the configuration of the bootstrap.
        // See less/cob/variables.less file and look for @navbarCollapseWidth
        return _$window.width() < 585;
    };

    var _addMenuOption = function(opt) {
        _$menusContainer.append($(tmpl_option(opt)));
    };

    var _addCobAppLink = function(app) {
        var _$newLi = $(tmpl_app_option(app));
        _$appsContainer.append(_$newLi);

        // IN IE8 we can't have a selector with :last-child
        _$appsContainer.find(".last").first().removeClass("last");
        _$newLi.addClass("last");
    };

    //When we click on a disabled option we do not want the menu to close
    var _onDisabledOptionClick = function(e){
        e.stopPropagation();
    };

    var _onWindowChange = function() {
        if (_isSmallDevice()) {
            _$smartMenu.reset();
            _$smartMenu.stop();

        } else {
            if (_$smartMenu.isStopped()) {
                _$smartMenu.adjust();
                _$smartMenu.start();
            }
        }
    };

    var _bindEvents = function() {
        _$menuBtn.on('click', function() {
            _$navContainer.collapse('toggle');
        });

        _$menusContainer.on('click', '.js-menu', function() {
            _$navContainer.collapse('hide');
        });

        _$window.on('resize.menu', _onWindowChange);

        _$window.on("orientationchange", function() {
            _$navContainer.collapse('hide');

            // start by hidding the menus
            // to avoid strange behaviours
            _$menusContainer.hide();
            setTimeout(function() {

                // show and adjust the menu.
                _$menusContainer.show();
                _$smartMenu.adjust();
            }, 200)
        });
    };

    return{
        init: function() {
            //start collapsed
            _$navContainer.collapse({toggle: false});
            _$smartMenu = _$menusContainer.smartMenu();

            _bindEvents();

            if (_isSmallDevice()) {
                _$smartMenu.stop();
            }

            // Since we changed the menu form to a template
            // we need to translate and append it to its container
            core.translate("cob.app", _$headerContainer, true);

            if (_appInfo.appId) {
                core.translate(_appInfo.appId.toLowerCase() + ".menu", _$headerContainer);
            }

            _$userDropdownMenu.on("click", ".disabled", _onDisabledOptionClick);

            $container.prepend(_$headerContainer);
        },
        addMenuOption: _addMenuOption,
        addCobApp: _addCobAppLink,
        showApps: function() {
            _$appsContainer.css("visibility", "visible");
        },
        showMenus: function() {
            _$menusContainer.css("visibility", "visible");
            _$smartMenu.adjust();
        },

        clearApps: function() {
            _$appsContainer.html('');
        },
        clearOpts: function() {
            _$menusContainer.html('');
        },

        setUsername: function(username) {
            _$usernameContainer.text(username);
        },
        showUserHasSubstituteMsg: function(substitute){
            _addSubstitutionMsg("being-substituted", "is-substitute", substitute);
        },
        showUserHasSubstitutionsMsg: function(){
            _addSubstitutionMsg("is-substitute", "being-substituted");
        },
        showUserIsImpersonating: _showUserIsImpersonating,
        hideUserIsImpersonating: _hideUserIsImpersonating,
        addUsersToSubstituteList: function(usersToSubstitute, userIsImpersonating, callback){
           var $usersToSubstituteList = $(tmpl_substitutes_list(
               {
                   title:core.translateString("cob.menu", "substitute-list-title"),
                   resetUserLink: userIsImpersonating ? core.translateString("cob.menu", "reset-user") : undefined,
                   usersToSubstitute: usersToSubstitute
               }
           ));

            $usersToSubstituteList.on("click", ".js-substitute-user", function(){
                /* eslint-disable-next-line no-invalid-this */
                var selectedUsername = $(this).attr("data-username");
                callback(selectedUsername);
            });

            _$userDropdownMenu.prepend($usersToSubstituteList);
        },
        removeUsersToSubstituteList:_removeUsersToSubstituteList,
        hideSubstitutionMsg: function(){
            _$substitutionWarning.addClass("hidden");
        },

        replaceUserProfileLink: function(userProfileUrl){
            var $oldProfileLink = $(".js-user-profile", _$userDropdownMenu),
                $newProfileLink = $(tmpl_user_profile_link({
                url: userProfileUrl,
                label: core.translateString("cob.menu", "my-profile")
            }));

            $oldProfileLink.remove();
            _$userDropdownMenu.append($newProfileLink);
        },

        show: function() {
            _$headerContainer.show();
            _$smartMenu.adjust();
        },

        hide: function() {
            _$userDropdownMenu.off("click", ".disabled", _onDisabledOptionClick);

            _$headerContainer.hide();
        }
    };
};

// callbacks:
//
// * `menuItemSelected`: called when a menu item is selected, with the _href_ of the clicked item
var MenuPresenter = function(core, $container) {

    var view = new MenuView(core, $container),
        _userDataInterval;

    var  _addUsersToSubstituteList = function(usersToSubstitute, userIsImpersonating){
        view.addUsersToSubstituteList(usersToSubstitute, userIsImpersonating, function(selectedUsername) {
            core.loginAs(selectedUsername);
        });
    };

    //If the user is being substituted and is substituting someone
    //we only show a warning message indicating for the former case and ignore the latter
    var _updateUserSubstitutionData = function() {
        var realUser = core.getRealUser();

        var userSubstitute = core.getUserSubstitute(),
            userIsBeingSubstituted = userSubstitute !== null && userSubstitute !== undefined,
            usersToSubstitute = core.getUsersToSubstitute();

        view.removeUsersToSubstituteList();
        view.replaceUserProfileLink(core.getUserProfileUrl());

        if(realUser){
            view.showUserIsImpersonating(core.getCurrentLoggedInUser());
            _addUsersToSubstituteList(usersToSubstitute, true);

        } else {

            view.hideUserIsImpersonating();

            if (userIsBeingSubstituted) {
                view.showUserHasSubstituteMsg(userSubstitute);

            } else {

                if (usersToSubstitute) {
                    view.showUserHasSubstitutionsMsg();
                    _addUsersToSubstituteList(usersToSubstitute, false);

                } else {
                    view.hideSubstitutionMsg();
                }
            }
        }
    };

    // we clear everything and generate all from the _Model_
    var _updateMenu = function(_e, opts) {

        // this is useful for menu customizations that want to change the menus in runtime
        const forceMenuRebuild = opts && opts.rebuildMenu;
        var appInfoModel = core.getAppInfoModel(forceMenuRebuild);

        view.clearApps();

        if (appInfoModel.apps.length > 0) {
            appInfoModel.apps.forEach(view.addCobApp);

            //we only show after the translation is done, so that the user doesn't see content in other langs
            core.translate(appInfoModel.appId.toLowerCase() + ".menu", ".js-cobapps", false, function() {
                view.showApps();
            });
        }

        view.clearOpts();
        appInfoModel.opts.forEach(view.addMenuOption);

        //we only show after the translation is done, so that the user doesn't see content in other langs
        if (appInfoModel.appId) {
            core.translate(appInfoModel.appId.toLowerCase() + ".menu", ".js-top-menu", false, function() {
                view.showMenus();
            });
        }

        _updateUserSubstitutionData();

        view.replaceUserProfileLink(core.getUserProfileUrl());

        view.setUsername(appInfoModel.username);
    };

    //We want to update the users data if the real user or the logged in user
    // or one of the users in the users to substitute list  was used on the update
    var _onUserUpdated = function(e, changedUser) {
        var _usernames = [core.getCurrentLoggedInUser(), core.getRealUser()],
            usersToSubstitute = core.getUsersToSubstitute();

        if(usersToSubstitute){
            usersToSubstitute.map(function(user){
                _usernames.push(user.username);
            });
        }

        var needToUpdateUserInfo = _usernames.indexOf(changedUser.username) >= 0 ||
                                   _usernames.indexOf(changedUser.substitutes.previous) >= 0 ||
                                   _usernames.indexOf(changedUser.substitutes.current) >= 0;

        if(needToUpdateUserInfo){
            window.clearInterval(_userDataInterval);
            core.updateUserInfo(_updateUserSubstitutionData);
        }
    };

    //init
    (function() {
        view.init();
        if (core.getAppMode() === 'naked') {
           view.hide();
        }
    }());

    var _start = function() {

        if (core.getAppMode() !== 'naked') {
            _updateMenu();
            view.show();

            //The application will request the logged in user data every minute
            //until this presenter is stopped
            _userDataInterval = window.setInterval(function() {
                core.updateUserInfo(_updateUserSubstitutionData);
            }, 60000); //60000 ms = 60 s

            core.subscribe("updated-app-info", _updateMenu);

            //If the logged in user changes its own substitute user we update its substitute info immediatly
            core.subscribe("user-data-changed", _onUserUpdated);
        }
    };

    var _stop = function() {
        core.unsubscribe("updated-app-info", _updateMenu);
        core.unsubscribe("user-data-changed", _onUserUpdated);

        view.hide();

        window.clearInterval(_userDataInterval);
    };

    return{
        start: _start,
        stop: _stop
    };
};

export default menu;
